import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/storage'
import * as firebaseUI from 'firebaseui'

const config = {
  apiKey: 'AIzaSyBDZKBM8rg_YZHBNZfzL4_g_pnVuD5LRIw',
  authDomain: 'poker-season-manager.firebaseapp.com',
  databaseURL: 'https://poker-season-manager.firebaseio.com',
  projectId: 'poker-season-manager',
  storageBucket: 'poker-season-manager.appspot.com',
  messagingSenderId: '566282137474'
}
firebase.initializeApp(config)

// firebase utils
export const db = firebase.firestore()
export const presenceDB = firebase.database()
export const auth = firebase.auth()
export const storage = firebase.storage()
export const fieldValue = firebase.firestore.FieldValue
export const fbUI = new firebaseUI.auth.AuthUI(firebase.auth())
export const fb = firebase
// firebase collections
const userCollection = db.collection('user')

// firebase google auth provider
const googleAuthProvider = firebase.auth.googleAuthProvider

// Realtime presenceDB online/offline constants
export const isOfflineForPresenceDB = {
  state: 0,
  last_changed: firebase.database.ServerValue.TIMESTAMP
}
export const isOnlineForPresenceDB = {
  state: 1,
  last_changed: firebase.database.ServerValue.TIMESTAMP
}

// Firestore uses a different server timestamp value, so we'll
// create two more constants for Firestore state.
var isOfflineForDB = {
  status: {
    state: 0,
    last_changed: firebase.firestore.FieldValue.serverTimestamp()
  }
}

var isOnlineForDB = {
  status: {
    state: 1,
    last_changed: firebase.firestore.FieldValue.serverTimestamp()
  }
}

export default {
  db,
  presenceDB,
  isOfflineForPresenceDB,
  isOnlineForPresenceDB,
  isOfflineForDB,
  isOnlineForDB,
  auth,
  userCollection,
  googleAuthProvider,
  fieldValue,
  firebase
}
